export default __webpack_public_path__ + "static/media/handover-grey.1085af56.svg";